(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("fuzzytree"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "fuzzytree"], factory);
	else if(typeof exports === 'object')
		exports["portage"] = factory(require("lodash"), require("fuzzytree"));
	else
		root["portage"] = factory(root["_"], root["FuzzyTree"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/